import CityDirectory from "../components/CityDirectory";

export default function UsCities() {
  return (
    <CityDirectory
      id="us-cities"
      title="United States City Guides"
      subtitle="Nearly 400 places — major metros, state capitals, regional centers, tourism destinations and fast-growing cities by region, plus iconic parks & attractions. Same-name cities are state-disambiguated (Portland ME vs OR, Charleston SC vs WV)."
      endpoint="/geo/us-cities"
      country="USA"
      searchPlaceholder="Search a city or state — try Austin, Alaska, Napa…"
      accent="#3c3b6e"
      docTitle="United States City Guides — 250+ Cities by Region | TravelerPulse"
    />
  );
}
